import { motion } from "framer-motion";
import { useLang } from "../lib/i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = [...t.clients, ...t.clients];
  return (
    <div className="py-20 sm:py-24" data-testid="trusted-by-strip">
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="text-center font-display font-bold tracking-tight text-2xl sm:text-3xl text-cream/85 px-5"
      >
        {t.marqueePre}{" "}
        <em className="font-serif italic font-medium text-brasslight">{t.marqueeAccent}</em> {t.marqueePost}
      </motion.h2>

      <div className="marquee mt-12 overflow-hidden" dir="ltr">
        <div className="marquee-track flex w-max items-stretch gap-14 pr-14">
          {items.map((c, i) => (
            <div key={i} className="flex flex-col items-start shrink-0" aria-hidden={i >= t.clients.length}>
              <span className="font-display text-xl sm:text-2xl font-bold text-cream/75 whitespace-nowrap">
                {c.name}
              </span>
              <span className="mt-1 text-xs font-semibold uppercase text-taupe">{c.sub}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
